import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { trackCheckoutClick } from '../utils/pixel';
import { useCountdown } from '../hooks/useCountdown';
interface FloatingCTAProps {
  /** Element the bar should appear after (the first hero CTA). */
  triggerRef: React.RefObject<HTMLElement>;
}
export function FloatingCTA({
  triggerRef
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  const {
    minutes,
    seconds
  } = useCountdown(17 * 60 + 34);
  useEffect(() => {
    const node = triggerRef.current;
    if (!node) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the hero CTA has scrolled out of view upward.
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [triggerRef]);
  return <AnimatePresence data-id="element-31" data-mp="2z38wuyf6c39o">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-navy/95 px-3 pb-[max(0.6rem,env(safe-area-inset-bottom))] pt-2.5 backdrop-blur-md" data-id="element-32" data-mp="2z4box9o8gbr6">
          <div className="mx-auto flex max-w-content items-center gap-3" data-id="element-33" data-mp="2fg2wqzmow5ro">
            <div className="hidden shrink-0 leading-tight sm:block" data-id="element-34" data-mp="2kemk94gxlpm5">
              <p className="text-[11px] font-bold uppercase tracking-widest text-brand-light" data-id="element-35" data-mp="26e20a4za5nr2">
                Oferta activa
              </p>
              <p className="font-sans text-lg font-black tabular-nums text-white" data-id="element-36" data-mp="2bcn0w5ig29g1">
                {minutes}:{seconds}
              </p>
            </div>
            <a href={CHECKOUT_URL} onClick={trackCheckoutClick} className="flex min-w-0 flex-1 items-center justify-center gap-2 rounded-xl bg-brand px-3 py-3.5 text-center text-[13px] font-extrabold uppercase leading-tight tracking-tight text-white shadow-[0_5px_0_0_#0E4CA8] transition-colors hover:bg-brand-dark sm:text-base" data-id="element-37" data-mp="9l9x5js7q7lk">
              <span className="truncate" data-id="element-38" data-mp="3pc82zkb06xta">Acceder por USD $14</span>
              <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-39" data-mp="3pe2ph31xaxzh" />
            </a>
          </div>
          <p className="mx-auto mt-1.5 max-w-content text-center text-[10.5px] font-medium text-white/60 sm:hidden" data-id="element-40" data-mp="qw5i5agyy7dw">
            Termina en {minutes}:{seconds} • Pago único • Garantía 7 días
          </p>
        </motion.div>}
    </AnimatePresence>;
}